import React, { useEffect, useState } from 'react'

import * as Api from "../../../../Config/Apis"
import endPoints from "../../../../Config/endPoints";
import * as Icon from 'react-bootstrap-icons';
import moment from 'moment/moment';
import _ from "underscore"
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import CurrencyFormat from 'react-currency-format';

import Images from '../../../../Assets/Images/Index';
import { useSelector } from 'react-redux';
import LineChart from './Charts/LineChart';
import ColumnChart from './Charts/ColumnChart';
import LineChartSingle from './Charts/LineChartSingle';
import PieChart from './Charts/PieChart';
import MultipleAxisBarChart from './Charts/MultipleAxisBarChart';
import StackedBarChart from './Charts/StackedBarChart';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { parse } from 'date-fns';
import { Form } from 'react-bootstrap';

const filter1 = [
  { name: "All", value: "" },
  { name: "Next 3 Months", value: "next3Months" },
  { name: "Next 6 Months", value: "next6Months" },
  { name: "Next 9 Months", value: "next9Months" },
  { name: "Next 12 months", value: "next12Months" },
]
const filter2 = [
  { name: "All", value: "" },
  { name: "Last 30 days", value: "last30days" },
  { name: "Last 60 days", value: "last60days" },
  { name: "Last 90 days", value: "last90days" },
  { name: "Last 120 days", value: "last120days" },
  { name: "Last 180 days", value: "last180days" },
  { name: "Last 365 days", value: "last365days" },
]

export default function RevenuePerformance() {
  const [chartData, setchartData] = useState({})
  const [loading, setloading] = useState(true)
  const [juiceup, setJuiceup] = useState(true)
  const [list, setList] = useState([
    { param: "", url: "MONTHLYREVENUE" },
    { param: "", url: "REVENUEBREAKDOWN" },
    { param: "", url: "LIFETIMEVALUE" },
    { param: "", url: "HIGHVALUECUSTOMER" },
    { param: "", url: "RELOADUSERS" }
  ])

  const [dates, setDates] = useState({
    "HIGHVALUECUSTOMER": {
      startDate: null,
      endDate: null
    },
    "RELOADUSERS": {
      startDate: null,
      endDate: null
    }

  });

  const getData = (url, param) => {
    Api.GetApi(`${endPoints[url]}${param}`).then(res => {
      console.log(`res123 ${url}`, res)
      setTimeout(() => {
        setloading(false)
      }, 1000);
      if (res.error === true) {
        Api.Alert(res.response.data.error, "error")
      } else {
        let chart_data = {}
        if (res.data.data) {
          if (url == "MONTHLYREVENUE" && res.data.data.length) {
            let months = []
            let actual = []
            let projected = []
            res.data.data.map((data) => {
              // months.push(`${data.month < 10 ? "0" + data.month : data.month}-${data.year}`)
              months.push(data.date)
              actual.push(data.revenue && data.revenue.toFixed(2))
              // projected.push(data.projected_revenue.toFixed(2))
            })
            chart_data["month"] = months
            chart_data["actual"] = actual
            chart_data["projected"] = projected
          }
          if (url == "REVENUEBREAKDOWN") {
            let labels = []
            let values = []
            let spent = []
            let percent = []
            if (res.data.data.total_map) {
              Object.entries(res.data.data.total_map).forEach(([key, val]) => {
                labels.push(key)
                values.push(val)
                spent.push(val.total_spend)
              })
              const total = spent.reduce((acc, val) => parseFloat(acc) + parseFloat(val), 0);
              values.map((val, index) => {
                const value = val.total_spend
                const percentage = ((value / total) * 100).toFixed(2) + "%";
                percent.push(`${labels[index]}: ${percentage}`)
              })

              chart_data["labels"] = percent
              chart_data["values"] = values
              console.log("percentage", percent)
            }
          }
        }
        setchartData((prevData) => ({
          ...prevData,
          [url]: {
            ...prevData[url],
            data: res.data.data,
            chart: chart_data,
          },
        }));
        // setloading(false)
      }
    })
  }

  const handleFilter = (e, key) => {
    let arr = []
    list.map((data) => {
      if (data.url == e.target.name) {
        const searchParams = new URLSearchParams(data.param)
        if (e.target.value) {
          searchParams.set(key, e.target.value)
        } else {
          searchParams.delete(key)
        }
        getData(data.url, `?${searchParams.toString()}`)
        arr.push({ ...data, param: searchParams.toString() })
      } else {
        arr.push(data)
      }
    })
    setList(arr)
  }
  const onDateChange = (dates, name) => {
    const [start, end] = dates;
    setDates((prevDates) => ({
      ...prevDates,
      [name]: {
        ...prevDates[name],
        startDate: start,
        endDate: end
      }
    }));

    let arr = []
    list.map((data) => {
      if (data.url == name) {
        const searchParams = new URLSearchParams(data.param)
        if (start && end) {
          searchParams.set("from", moment(start).format("YYYY-MM-DD"))
          searchParams.set("to", moment(end).format("YYYY-MM-DD"))
          getData(data.url, `?${searchParams.toString()}`)
        } else {
          searchParams.delete("from")
          searchParams.delete("to")
          if (!start) {
            getData(data.url, `?${searchParams.toString()}`)
          }
        }
        arr.push({ ...data, param: searchParams.toString() })
      } else {
        arr.push(data)
      }
    })
    setList(arr)

  };

  const toggleState = (e) => {
    setJuiceup(e.target.checked);
  }

  useEffect(() => {
    list.filter((data) => data.nofilter).map((data) => {
      getData(data.url, "")
    })
  }, [])

  useEffect(() => {
    let arr = []
    list.filter((data) => !data.nofilter).map((data) => {
      const searchParams = new URLSearchParams(data.param)
      searchParams.set("juiceup", juiceup)
      searchParams.delete("from")
      searchParams.delete("to")
      arr.push({ ...data, param: searchParams.toString() })
      setList(arr)
      getData(data.url, `?${searchParams.toString()}`)
      setDates((prevDates) => ({
        ...prevDates,
        [data.url]: {
          ...prevDates[data.url],
          startDate: null,
          endDate: null
        }
      }));
    })
  }, [juiceup])

  console.log("chartData", chartData)
  console.log("list", list)

  return (
    <>

      {loading ?
        <div className="loader-line"></div> :
        <main id="main" className="main">
          <div className="d-flex align-items-center justify-content-between mb-1">
            <div className="pagetitle">
              <h1>Revenue & Growth</h1>
            </div>
            <Form className='d-flex align-items-center '>
              <Form.Check
                className='mb-0'
                type="switch"
                label={"Juiceup"}
                checked={juiceup}
                onChange={toggleState}
              />
            </Form>
          </div>
          <section className='section dashboard '>
            <div className='row'>
              <div className="col-xxl-7 col-xl-6">
                <div className="card info-card sales-card mb-4">
                  <div className="card-body dashCard">
                    <div className="d-flex align-items-center justify-content-between mb-1">
                      <h5 className="card-title pb-2 m-md-0">Monthly Revenue Growth & Projection</h5>
                      <div className="d-flex align-items-center justify-content-end">
                        <select className="ms-2 form-select dashFilterSelect form-md" aria-label="Default select example" name="MONTHLYREVENUE" onChange={(e) => handleFilter(e, "filter")}>
                          {filter1.map((data, indx) => {
                            return <option value={data.value} key={indx}>{data.name}</option>
                          })}
                        </select>
                      </div>
                    </div>
                    {chartData && chartData.MONTHLYREVENUE && chartData.MONTHLYREVENUE.chart ?
                      <div className="dashBarChartHolder" style={{
                        height: "220px",
                      }}>
                        <LineChart
                          data={chartData.MONTHLYREVENUE.chart}
                          labels={chartData.MONTHLYREVENUE.chart.month}
                          chart={[
                            {
                              label: "Revenue",
                              data: chartData.MONTHLYREVENUE.chart.actual,
                              borderColor: "green",
                              backgroundColor: "rgba(0, 255, 0, 0.2)",
                              borderWidth: 2,
                              fill: false,
                              tension: 0.1,
                              pointRadius: 0
                            },
                            // {
                            //   label: "Projected revenue",
                            //   data: chartData.MONTHLYREVENUE.chart.projected,
                            //   borderColor: "red",
                            //   backgroundColor: "rgba(255, 0, 0, 0.2)",
                            //   borderWidth: 2,
                            //   fill: false,
                            //   tension: 0.1,
                            //   borderDash: [5, 5],
                            //   pointRadius: 0
                            // },
                          ]}
                        />
                      </div>
                      : null
                    }
                  </div>
                </div>
              </div>
              <div className="col-xxl-5 col-xl-6">
                <div className="card info-card sales-card mb-4">
                  <div className="card-body dashCard">
                    <div className="d-flex align-items-center justify-content-between mb-1">
                      <h5 className="card-title pb-2 m-md-0">Customer Lifetime Value(LTV)</h5>
                      <div className="d-flex align-items-center justify-content-end">
                        <select className="ms-2 form-select dashFilterSelect form-md" aria-label="Default select example" name="LIFETIMEVALUE" onChange={(e) => handleFilter(e, "filter")}>
                          {filter2.map((data, indx) => {
                            return <option value={data.value} key={indx}>{data.name}</option>
                          })}
                        </select>
                      </div>
                    </div>
                    {chartData && chartData.LIFETIMEVALUE && chartData.LIFETIMEVALUE.data ?
                      <h3 className='mb-0'>
                        <CurrencyFormat value={chartData.LIFETIMEVALUE.data.ltv.toFixed(2) || 0} displayType={'text'} thousandSeparator={true} prefix={''} />
                      </h3>
                      : null
                    }
                    <hr style={{ margin: "10px 0" }} />
                    <div className='row align-items-end'>
                      {chartData && chartData.LIFETIMEVALUE && chartData.LIFETIMEVALUE.data ?
                        <div className="col-md-6">
                          <div className="d-flex gap-1 gap-md-2">
                            <div className="card-icon rounded-circle ">
                              <Icon.CurrencyDollar className="me-0" />
                              {/* <img src={Images.moneyBag} /> */}
                              <small><strong>MYR</strong></small>
                            </div>
                            <div className="ps-1">
                              <div className="mb-3">
                                <h4 className='mb-0'>
                                  <CurrencyFormat value={parseFloat(chartData.LIFETIMEVALUE.data.total_revenue.toFixed(2) || "0")} displayType={'text'} thousandSeparator={true} prefix={'RM'} />
                                </h4>
                                <h5 className="card-title pb-0 font-med">Total revenue</h5>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex gap-1 gap-md-2">
                            <div className="card-icon rounded-circle ">
                              <Icon.Person className="me-0" />
                            </div>
                            <div className="ps-1">
                              <div className="mb-3">
                                <h4 className='mb-0'>
                                  <CurrencyFormat value={chartData.LIFETIMEVALUE.data.active_user_count || 0} displayType={'text'} thousandSeparator={true} prefix={''} />
                                </h4>
                                <h5 className="card-title pb-0 font-med">Active users</h5>
                              </div>
                            </div>
                          </div>
                          {/* <div className="d-flex gap-1 gap-md-2">
                            <div className="card-icon rounded-circle ">
                              <Icon.Person className="me-0" />
                            </div>
                            <div className="ps-1">
                              <div className="mb-0">
                                <h3 className='mb-0'>
                                  <CurrencyFormat value={chartData.LIFETIMEVALUE.data.ltv.toFixed(2) || 0} displayType={'text'} thousandSeparator={true} prefix={''} />
                                </h3>
                                <h5 className="card-title pb-0 font-med">LTV</h5>
                              </div>
                            </div>
                          </div> */}
                        </div>
                        : null
                      }

                      <div className="col-md-6">
                        {chartData && chartData.LIFETIMEVALUE && chartData.LIFETIMEVALUE.data && chartData.LIFETIMEVALUE.data.sales.length ?
                          <div className="dashBarChartHolder" style={{
                            height: "150px",
                          }}>
                            <LineChartSingle
                              data={chartData.LIFETIMEVALUE.data.sales.map((data) => data.amount.toFixed(2) || 0) || []}
                              label={chartData.LIFETIMEVALUE.data.sales.map((_) => ` `)}
                              labels={["Amount (RM)"]}
                              tooltip={chartData.LIFETIMEVALUE.data.sales.map((data) => `${data._id}, Sessions: ${data.count}`) || []}
                            />
                          </div>
                          : null
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card info-card sales-card mb-4">
              <div className="card-body dashCard">
                <div className="d-flex align-items-center justify-content-between mb-1">
                  <h5 className="card-title pb-2 m-md-0">Top 50 High-Value Customers (HVCs)</h5>
                  <div className='date-range-outer'>
                    <DatePicker
                      onChange={(e) => onDateChange(e, "HIGHVALUECUSTOMER")}
                      selected={dates.HIGHVALUECUSTOMER.startDate}
                      startDate={dates.HIGHVALUECUSTOMER.startDate}
                      endDate={dates.HIGHVALUECUSTOMER.endDate}
                      selectsRange
                      maxDate={new Date()}
                      placeholderText="Select date range"
                      className="form-control datepicker"
                      isClearable={true}
                    />
                  </div>
                </div>
                {chartData.HIGHVALUECUSTOMER && chartData.HIGHVALUECUSTOMER.data && chartData.HIGHVALUECUSTOMER.data.data && chartData.HIGHVALUECUSTOMER.data.data.length > 0 ?
                  <div className='row'>
                    <div className='col-lg-5'>
                      <div className="chart-table table-responsive">
                        <table className="table dataTable copartnerTable">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Email/phone</th>
                              <th scope="col">Total spent</th>
                              <th scope="col">Sessions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {chartData.HIGHVALUECUSTOMER.data.data.map((data, index) => {
                              return (
                                <tr key={index} >
                                  <td>
                                    <strong>{data?.first_name || ""} {data?.last_name || ""}</strong><br />
                                    <small style={{ fontSize: "70%" }}>{data.user_id}</small>
                                  </td>
                                  <td>
                                    {data?.email || ""}<br />
                                    {data?.Phone_Number || ""}
                                  </td>
                                  <td>
                                    <CurrencyFormat value={parseFloat(data?.total_amount_spent).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'RM '} />
                                  </td>
                                  <td>{data?.session_count || ""}</td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className='col-lg-7'>
                      {chartData && chartData.HIGHVALUECUSTOMER && chartData.HIGHVALUECUSTOMER.data && chartData.HIGHVALUECUSTOMER.data.data.length ?
                        <div className="dashBarChartHolder" style={{
                          height: "auto",
                        }}>
                          <MultipleAxisBarChart
                            data={[
                              {
                                label: "Total Amount Spent (RM)",
                                data: chartData.HIGHVALUECUSTOMER.data.data.map((c) => c.total_amount_spent),
                                backgroundColor: "rgba(75, 192, 192, 1)", // Green bars
                                borderRadius: 0,
                                yAxisID: "y",
                              },
                              {
                                label: "Session Count",
                                data: chartData.HIGHVALUECUSTOMER.data.data.map((c) => c.session_count),
                                backgroundColor: "rgba(255, 99, 132, 1)", // Red bars
                                borderRadius: 0,
                                yAxisID: "y1",
                              },
                            ]}
                            xText={`Average Spending/Session: RM${parseFloat(chartData.HIGHVALUECUSTOMER.data.session_average).toFixed(2)}`}
                            text1="Total Amount Spent (RM)"
                            text2="Session Count"
                            label={chartData.HIGHVALUECUSTOMER.data.data.map((_,) => ` `)}
                            // tooltip={chartData.HIGHVALUECUSTOMER.data.map((value) => `User ID: ${value.user_id}`)}
                            tooltip={{
                              callbacks: {
                                title: (tooltipItems) => {
                                  const index = tooltipItems[0].dataIndex;
                                  return `${chartData.HIGHVALUECUSTOMER.data.data[index].first_name} ${chartData.HIGHVALUECUSTOMER.data.data[index].last_name}`;
                                }
                              },
                            }}
                          />
                        </div>
                        : null
                      }
                    </div>
                  </div>
                  :
                  <div className='px-3 py-3 text-center'>
                    <h3>No data available</h3>
                  </div>
                }
              </div>
            </div>
            <div className="card info-card sales-card mb-4">
              <div className="card-body dashCard">
                <div className="d-flex align-items-center justify-content-between mb-1">
                  <h5 className="card-title pb-2 m-md-0">Top 50 Most Frequent Reload Users</h5>
                  <div className='date-range-outer'>
                    <DatePicker
                      onChange={(e) => onDateChange(e, "RELOADUSERS")}
                      selected={dates.RELOADUSERS.startDate}
                      startDate={dates.RELOADUSERS.startDate}
                      endDate={dates.RELOADUSERS.endDate}
                      selectsRange
                      maxDate={new Date()}
                      placeholderText="Select date range"
                      className="form-control datepicker"
                      isClearable={true}
                    />
                  </div>
                </div>
                {chartData.RELOADUSERS && chartData.RELOADUSERS.data && chartData.RELOADUSERS.data.length > 0 ?
                  <div className='row'>
                    <div className='col-lg-5'>
                      <div className="chart-table table-responsive">
                        <table className="table dataTable copartnerTable">
                          <thead>
                            <tr>
                              <th scope="col">User</th>
                              <th scope="col">Total amount</th>
                              <th scope="col">Total reloads</th>
                              <th scope="col">Last reload</th>
                            </tr>
                          </thead>
                          <tbody>
                            {chartData.RELOADUSERS.data.map((data, index) => {
                              return (
                                <tr key={index} >
                                  <td>
                                    <strong>{data?.name || ""}</strong><br />
                                    <small style={{ fontSize: "70%" }}>{data.userId}</small>
                                  </td>
                                  <td>
                                    <CurrencyFormat value={parseFloat(data?.totalAmount).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'RM '} />
                                  </td>
                                  <td>
                                    {data?.totalReloads || 0}
                                  </td>
                                  <td>
                                    {moment(data?.lastTopup).format("ll")}
                                  </td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className='col-lg-7'>
                      {chartData && chartData.RELOADUSERS && chartData.RELOADUSERS.data.length ?
                        <div className="dashBarChartHolder" style={{
                          height: "400px",
                        }}>
                          {/* <LineChartSingle
                            data={chartData.RELOADUSERS.data.map((c) => c.totalReloads || 0) || []}
                            label={chartData.RELOADUSERS.data.map((_) => ` `)}
                            labels={["Reload Users"]}
                            tooltip={chartData.RELOADUSERS.data.map((data) => `Name: ${data.name || ""}\nEmail: ${data.email || ""}`) || []}
                          /> */}
                          <StackedBarChart
                            data={[
                              {
                                label: "Reload Users",
                                data: chartData.RELOADUSERS.data.map((c) => c.totalReloads || 0) || [],
                                backgroundColor: "rgba(255, 99, 132, 1)",
                              }
                            ]}
                            labels={chartData.RELOADUSERS.data.map((_) => ` `)}
                            tooltip={chartData.RELOADUSERS.data.map((data) => `Name: ${data.name || ""}\nEmail: ${data.email || ""}`) || []}
                            legend
                            position={"bottom"}
                          />
                        </div>
                        : null
                      }
                    </div>
                  </div>
                  :
                  <div className='px-3 py-3 text-center'>
                    <h3>No data available</h3>
                  </div>
                }
              </div>
            </div>


            <div className="card info-card sales-card mb-4">
              <div className="card-body dashCard">
                <div className="d-flex align-items-center justify-content-between mb-4">
                  <h5 className="card-title pb-2 m-md-0">Revenue Breakdown by Charger Type (AC/DC)</h5>
                  <div className="d-flex align-items-center justify-content-end">
                    <select className="ms-2 form-select dashFilterSelect form-md" aria-label="Default select example" name="REVENUEBREAKDOWN" onChange={(e) => handleFilter(e, "filter")}>
                      {filter2.map((data, indx) => {
                        return <option value={data.value} key={indx}>{data.name}</option>
                      })}
                    </select>
                  </div>
                </div>
                <div className='row justify-content-between'>
                  <div className="col-lg-4">
                    {chartData && chartData.REVENUEBREAKDOWN && chartData.REVENUEBREAKDOWN.chart && chartData.REVENUEBREAKDOWN.chart.values && chartData.REVENUEBREAKDOWN.chart.values.length ?
                      <div className="dashBarChartHolder" style={{
                        height: "auto",
                      }}>
                        <PieChart
                          data={chartData.REVENUEBREAKDOWN.chart.values.map((value) => value.total_spend.toFixed(2))}
                          // tooltip={chartData.REVENUEBREAKDOWN.chart.values.map((value) => `Sessions: ${value.total_count}\n Revenue (RM): ${value.total_spend.toFixed(2)}`)}
                          tooltip={{
                            enabled: true,
                            callbacks: {
                              title: (tooltipItem) => {
                                const index = tooltipItem[0].dataIndex;
                                return `Sessions: ${chartData.REVENUEBREAKDOWN.chart.values[index].total_count}\n Revenue (RM): ${chartData.REVENUEBREAKDOWN.chart.values[index].total_spend.toFixed(2)}`;
                              },
                              label: (tooltipItem) => {
                                const dataset = tooltipItem.dataset;
                                const total = dataset.data.reduce((acc, val) => parseFloat(acc) + parseFloat(val), 0);
                                const value = dataset.data[tooltipItem.dataIndex]
                                const percentage = ((value / total) * 100).toFixed(2) + "%";

                                const index = tooltipItem.dataIndex;
                                return `Sessions: ${value} (${percentage})`;
                              }
                            },
                          }}
                          labels={chartData.REVENUEBREAKDOWN.chart.labels}
                        />
                      </div>
                      : null
                    }
                  </div>
                  <div className="col-lg-7">
                    {chartData && chartData.REVENUEBREAKDOWN && chartData.REVENUEBREAKDOWN.data && chartData.REVENUEBREAKDOWN.data.location && chartData.REVENUEBREAKDOWN.data.location.length ?
                      <div className="dashBarChartHolder" style={{
                        height: "auto",
                      }}>
                        {/* <MultiAxisChart
                          data1={chartData.REVENUEBREAKDOWN.data.location.map((c) => c.total_revenue)}
                          data2={chartData.REVENUEBREAKDOWN.data.location.map((c) => c.total_session)}
                          labels={["Total Revenue (RM)", "Total Session"]}
                          label={chartData.REVENUEBREAKDOWN.data.location.map((value) => ` `)}
                          tooltip={chartData.REVENUEBREAKDOWN.data.location.map((value) => `Location: ${value.operator_name}`)}
                        /> */}

                        <MultipleAxisBarChart
                          data={[
                            {
                              label: "Total Revenue (RM)",
                              data: chartData.REVENUEBREAKDOWN.data.location.map((c) => c.total_revenue),
                              backgroundColor: "rgba(75, 192, 192, 1)", // Green bars
                              borderRadius: 0,
                              yAxisID: "y1",
                            },
                            {
                              label: "Total Session",
                              data: chartData.REVENUEBREAKDOWN.data.location.map((c) => c.total_session),
                              backgroundColor: "rgba(255, 99, 132, 1)", // Red bars
                              borderRadius: 0,
                              yAxisID: "y",
                            },
                          ]}
                          text1="Total Revenue (RM)"
                          text2="Total Session"
                          label={chartData.REVENUEBREAKDOWN.data.location.map((c) => c.operator_name)}
                          // tooltip={chartData.REVENUEBREAKDOWN.data.map((value) => `User ID: ${value.user_id}`)}
                          tooltip={{
                            callbacks: {
                              title: (tooltipItems) => {
                                const index = tooltipItems[0].dataIndex;
                                return `Location: ${chartData.REVENUEBREAKDOWN.data.location[index].operator_name}`;
                              }
                            },
                          }}
                        />
                      </div>
                      : null
                    }
                  </div>
                </div>
              </div>
            </div>

          </section>

        </main>
      }

    </>
  )
}
